import { render, staticRenderFns } from "./VekaletListeView.vue?vue&type=template&id=1250ece8"
import script from "./VekaletListeView.vue?vue&type=script&lang=ts"
export * from "./VekaletListeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports